import { Outlet } from "react-router-dom";
import Redirect from "components/common/Redirect";
import { useProject } from "context/ProjectContext";
import usePermissions from "hooks/permissions";
import { IProjectPermissions } from "models/permissions.models";
import { Path } from "utils/constants/paths.constants";

type TProjectPermissionGuardProps = {
  check: (permissions: IProjectPermissions) => boolean;
  deniedPath?: Path;
};

export const ProjectPermissionGuard = ({
  check,
  deniedPath = Path.ProjectDocuments,
}: TProjectPermissionGuardProps) => {
  const { project, isProjectLoading } = useProject();
  const { isLoading, permissions } = usePermissions(project?.id ?? "");

  if (isProjectLoading || isLoading) {
    return null;
  }

  if (!check(permissions)) {
    return <Redirect path={deniedPath} />;
  }

  return <Outlet />;
};
